import React, { useEffect, useState } from "react";
import { useAsidebarEditor } from "../../hooks/asidebarEditor";
import ClausesView from "../ClausesView";
import UploadImages from "../UploadImages";
import CommentsView from "../CommentsView";
import GroupElements from "../GroupElementsView";
import TemplatesView from "../TemplatesView";
import Icons from "../IconsApi";
import VersioningProject from "../VersioningProject";
import ElementsKonva from "../ElementsKonva";
import AutomatizingTab from "../AutomatizingTab";

const AsidebarComponents: React.FC = () => {
  const { isActive, handleActiveButton, selectedTab, setSelectedTab } =
    useAsidebarEditor();

  const [search, setSearch] = useState("");

  useEffect(() => {
    if (selectedTab === "none") {
      setSelectedTab("templates");
    }
  }, [selectedTab]);

  return (
    <>
      {selectedTab === "templates" && (
        <TemplatesView search={search} setSearch={setSearch} />
      )}
      {selectedTab === "clauses" && (
        <ClausesView
          isActive={isActive}
          handleActiveButton={handleActiveButton}
        />
      )}
      {selectedTab === "groupElements" && <GroupElements />}
      {selectedTab === "elements" && <ElementsKonva />}
      {selectedTab === "icons" && <Icons />}
      {selectedTab === "upload" && <UploadImages />}
      {selectedTab === "comments" && <CommentsView />}
      {selectedTab === "controlOfVersions" && <VersioningProject />}
      {selectedTab === "automatizing" && <AutomatizingTab />}
    </>
  );
};

export default AsidebarComponents;
